import { getRewardProgramData } from "@/app/product/_actions/user.actions";

// getRewardProgramData is a "use server" action - it runs on the Next.js
// server, so a cache declared inside that file would be shared across every
// user hitting the server process (a privacy bug, not just a performance
// one). This cache lives here instead, in client-side browser memory,
// correctly scoped to one user's session - same reasoning as the shared
// cache in useConfig.ts.
//
// DynamicBannerCarousel and RewardsSection (mounted globally via
// FloatingActionsBar in the root layout) both independently fetch this same
// data for the same logged-in user; wrapping the action here lets both
// share one in-flight/completed request instead of firing one each.
let cached: {
	key: string;
	promise: ReturnType<typeof getRewardProgramData>;
} | null = null;

export function fetchRewardProgramData(isAuthorized: boolean) {
	if (!isAuthorized) {
		cached = null;
		return Promise.resolve({
			success: false as const,
			error: true as const,
			errorText: "Not authorized",
		});
	}

	const key = "authorized";
	if (!cached || cached.key !== key) {
		cached = { key, promise: getRewardProgramData() };
	}
	return cached.promise;
}
